import {observable} from 'mobx';

export default class BaseStyleSettings {
	@observable is_default;
	@observable content;

	constructor(settings) {
		if (settings) {
			this.is_default = settings.is_default;
			this.content = settings.content;
		}
	}
}